/* kfpkg(ZIP) 검사 — 내부 kmodel_info.bin(1000B 패딩 JSON)에서 모델 종류를 감지.
   구조 정본: Huenit docs/references/05-AI학습서버-API.md —
     YOLO:           { model_info:"yolo_Huenit", Class_Num, Class_Names:[...], ... }
     Classification: { model_info:"classification_Huenit", Class_Num }   (클래스 이름 없음)
   외부 라이브러리 없이 EOCD → central directory 를 직접 파싱(엔트리 수 소수).
   deflate 엔트리는 브라우저 DecompressionStream('deflate-raw') 사용.
   감지는 best-effort — 어떤 실패든 null 반환(업로드 자체는 막지 않음). */

const td = new TextDecoder();

/* buffer(ArrayBuffer) → { modelInfo, classNum, classNames } | null */
export async function inspectKfpkg(buffer) {
  try {
    const bytes = new Uint8Array(buffer);
    const dv = new DataView(buffer);
    // EOCD(0x06054b50) — 뒤에서부터 스캔(주석 최대 64KB 허용).
    let eocd = -1;
    const min = Math.max(0, bytes.length - 65558);
    for (let i = bytes.length - 22; i >= min; i--) {
      if (dv.getUint32(i, true) === 0x06054b50) { eocd = i; break; }
    }
    if (eocd < 0) return null;
    const count = dv.getUint16(eocd + 10, true);
    let ofs = dv.getUint32(eocd + 16, true);

    for (let n = 0; n < count; n++) {
      if (dv.getUint32(ofs, true) !== 0x02014b50) break;   // central header sig
      const method = dv.getUint16(ofs + 10, true);
      const csize = dv.getUint32(ofs + 20, true);
      const nameLen = dv.getUint16(ofs + 28, true);
      const extraLen = dv.getUint16(ofs + 30, true);
      const cmtLen = dv.getUint16(ofs + 32, true);
      const lho = dv.getUint32(ofs + 42, true);
      const name = td.decode(bytes.subarray(ofs + 46, ofs + 46 + nameLen));

      if (name.split('/').pop() === 'kmodel_info.bin') {
        if (dv.getUint32(lho, true) !== 0x04034b50) return null;   // local header sig
        const ln = dv.getUint16(lho + 26, true);
        const le = dv.getUint16(lho + 28, true);
        const start = lho + 30 + ln + le;
        let data = bytes.subarray(start, start + csize);
        if (method === 8) {
          const ds = new DecompressionStream('deflate-raw');
          const resp = new Response(new Blob([data]).stream().pipeThrough(ds));
          data = new Uint8Array(await resp.arrayBuffer());
        } else if (method !== 0) {
          return null;                                     // 미지원 압축
        }
        // 1000B 패딩 → 첫 '{' ~ 마지막 '}' 만 파싱.
        const text = td.decode(data);
        const a = text.indexOf('{');
        const b = text.lastIndexOf('}');
        if (a < 0 || b <= a) return null;
        const json = JSON.parse(text.slice(a, b + 1));
        return {
          modelInfo: String(json.model_info || ''),
          classNum: json.Class_Num != null ? Number(json.Class_Num) : null,
          classNames: Array.isArray(json.Class_Names) ? json.Class_Names : null,
        };
      }
      ofs += 46 + nameLen + extraLen + cmtLen;
    }
    return null;
  } catch (e) {
    return null;
  }
}

/* kmodel_info(또는 파일명 폴백) → CMS 모델 종류 값.
   앱(_modelTypeOf)은 값에 yolo/detection 포함 → 탐지(YOLO), 그 외 → 분류로 동작하므로
   object_detection / classification 시드 값과 정합. */
export function detectTypeValue(info, fileName) {
  const s = (((info && info.modelInfo) || '') + ' ' + (fileName || '')).toLowerCase();
  if (/yolo|detect/.test(s)) return 'object_detection';
  if (/classif/.test(s)) return 'classification';
  return null;
}
